export default __webpack_public_path__ + "app/audio/coin.mp3";